if (!customElements.get('testimonials-slider')) {
  class TestimonialsSlider extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        swiper: '.testimonials__slider',
        next: '.testimonials__button--next',
        prev: '.testimonials__button--prev',
        pagination: '.testimonials__pagination',
      };

      this.swiper = null;

      this.initSlider();
    }

    initSlider() {
      const swiperEl = this.querySelector(this.selectors.swiper);
      if (!swiperEl || !window.Swiper) return;

      const gapDesktop = parseInt(swiperEl.dataset.gapDesktop, 10) || 24;
      const gapMobile = parseInt(swiperEl.dataset.gapMobile, 10) || 12;
      const slidesDesktop = parseFloat(swiperEl.dataset.slidesDesktop) || 3;
      const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(swiperEl.dataset.autoplaySpeed, 10) || 5000;

      // Loop needs more slides than fit in a view, otherwise Swiper locks the
      // slider and logs "not enough slides for loop mode". Guard against it.
      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      const loop = swiperEl.dataset.loop === 'true' && slideCount > Math.ceil(slidesDesktop);

      const swiperConfig = {
        slidesPerView: 1.2,
        spaceBetween: gapMobile,
        watchSlidesProgress: true,
        watchOverflow: true,
        loop,
        autoplay: autoplayEnabled
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        navigation: {
          nextEl: this.querySelector(this.selectors.next),
          prevEl: this.querySelector(this.selectors.prev),
        },
        pagination: {
          el: this.querySelector(this.selectors.pagination),
          clickable: true,
        },
        breakpoints: {
          480: {
            slidesPerView: 1.35,
            spaceBetween: gapMobile,
          },
          576: {
            slidesPerView: 1.5,
            spaceBetween: gapMobile,
          },
          675: {
            slidesPerView: 2.1,
            spaceBetween: gapMobile,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: gapDesktop,
          },
          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop,
          },
        },
      };

      this.swiper = new window.Swiper(swiperEl, swiperConfig);
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider);
}
